import { apiRequest } from './api';

export const projectService = {
  getProjects: () => apiRequest('/api/projects'),
  getFeaturedProjects: () => apiRequest('/api/projects/featured')
};
